module.exports = __webpack_public_path__ + "static/cosyzebra1-b0336031ee6deade0458638ce3f653ec.png";